import { render, staticRenderFns } from "./OrderShow.vue?vue&type=template&id=1b36ca86"
import script from "./OrderShow.vue?vue&type=script&lang=ts"
export * from "./OrderShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports